import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';
import { WaterManagementDecisionAutocomplete } from '../../models/water-management-decision';

export function useWaterManagementDecisions() {
  return useAutocompleteSource<WaterManagementDecisionAutocomplete>({
    url: `${EvidenceAPI.WATER_MANAGEMENT_DECISIONS}/autocomplete`,
  });
}
